// extracted by mini-css-extract-plugin
export default {"container":"DicePanel_container__ix4WG"};